import { useTranslation } from 'react-i18next'

import { Button } from 'src/components/Button/Button'
import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { useLocale } from 'src/contexts/LocaleContext'
import { getMetafield } from 'src/functions/util/getMetafield'

import styles from './SubcollectionHeader.module.scss'

import type { Collection } from 'src/data/graphql-generated'

interface SubcollectionHeaderProps {
  subcollection: Collection
}

export const SubcollectionHeader = ({ subcollection }: SubcollectionHeaderProps) => {
  const { t } = useTranslation()
  const { language } = useLocale()
  const { title, handle, metafields } = subcollection

  const pageType = getMetafield(metafields, 'layout', 'page_type')?.charAt(0) || 'g'

  return (
    <Container className={styles.container}>
      <Headline variant="h2">{title}</Headline>
      <Button variant="secondary" href={`/${language}/${pageType}/${handle}`}>
        {t('common.showAll')}
      </Button>
    </Container>
  )
}
